import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import '../../polyfills';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CsvRoutingModule } from './csv-routing.module';
import { BrokersListComponent, SelectBrokerDialogContent } from './brokers-list/brokers-list.component';
import { SharedAngularModuleModule } from '../shared-angular-module/shared-angular-module.module';
import { ImportCsvFileComponent } from './import-csv-file/import-csv-file.component';
@NgModule({
  declarations: [BrokersListComponent,
    SelectBrokerDialogContent,
    ImportCsvFileComponent],
  imports: [
    CommonModule,
    CsvRoutingModule,
    SharedAngularModuleModule,
    OverlayModule,
    ReactiveFormsModule,
    FormsModule
  ],
  entryComponents: [
    SelectBrokerDialogContent
  ]
})
export class CsvModule { }
